import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
export const useLocaleQueryParams = () => {
  const {
    search
  } = useLocation();
  const history = useHistory();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const localeQueryParam = searchParams.get('locale');
  const updateLocaleQueryParam = useCallback(newLocale => {
    searchParams.set('locale', newLocale);
    history.push({
      search: searchParams.toString()
    });
  }, [history, searchParams]);
  return {
    localeQueryParam,
    updateLocaleQueryParam
  };
};